import { useState } from "react";
import {
  closeTrade,
  fetchBalance,
  placeGTTOrder,
} from "../services/tradeService";
// import { useTrades } from "./useTrades";
import useWebSocket from "./useWebSocket";
import { PlaceWithGTTParams } from "../commons/interface";
import { useNotifications } from "@toolpad/core/useNotifications";

export function useTrade() {
  // const { refreshTrades } = useTrades();
  const { sendMessage } = useWebSocket();
  const [openModal, setOpenModal] = useState(false);
  const [tradeModalSymbol, setTradeModalSymbol] = useState<string | null>(null);
  const [instrumentToken, setInstrumentToken] = useState<number | null>(null);
  const [lastPrice, setLastPrice] = useState<string | null>(null);
  const [currentBalance, setCurrentBalance] = useState<number | null>(null);
  const notifications = useNotifications();

  const openTradeModal = async (
    symbol: string,
    lastPrice: string,
    instrumentToken: number
  ) => {
    setOpenModal(true);
    setTradeModalSymbol(symbol);
    setInstrumentToken(instrumentToken);
    setLastPrice(lastPrice);
    try {
      const balanceData = await fetchBalance();
      const availableBalance = balanceData?.data?.available_margin?.equity || 0;
      setCurrentBalance(availableBalance);
    } catch (err) {
      console.error("Error fetching balance:", err);
    }
  };

  const closeTradeModal = () => {
    setOpenModal(false);
    setTradeModalSymbol(null);
    setInstrumentToken(null);
    setCurrentBalance(null);
  };

  const confirmTrade = async (params: PlaceWithGTTParams) => {
    if (!params.symbol) return;

    try {
      await placeGTTOrder(params);
      notifications.show(
        `✅ Order and GTT placed successfully for ${params.symbol}`,
        {
          autoHideDuration: 3000,
        }
      );
      // refreshTrades();
      return;
    } catch (err) {
      console.error("Error placing trade:", err);
    } finally {
      closeTradeModal();
    }
  };

  const manualCloseTrade = async (tradeId: string) => {
    try {
      await closeTrade(tradeId);
      // refreshTrades();
      sendMessage({ type: "TRADE_CLOSED", tradeId });
    } catch (err) {
      console.error("Error closing trade:", err);
    }
  };

  return {
    openModal,
    tradeModalSymbol,
    instrumentToken,
    lastPrice,
    currentBalance,
    openTradeModal,
    closeTradeModal,
    confirmTrade,
    manualCloseTrade,
  };
}
